function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9 .429A8.571 8.571 0 11.429 9 8.57 8.57 0 018.999.429zm0 1.142a7.43 7.43 0 000 14.858 7.43 7.43 0 00-.001-14.858zm3.479 4.674c.268-.258.625-.341.918-.108a.58.58 0 01.049.893l-4.537 5.492a.766.766 0 01-.519.207h-.014a.768.768 0 01-.513-.19l-2.656-2.368a.578.578 0 01.008-.893.793.793 0 011.019.008l2.121 1.892c2.57-3.116 3.945-4.76 4.124-4.933z",
  fill: "#FFF",
  fillRule: "nonzero"
});

function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _ref);
}

export default SvgSuccess;